import createActionType from "../utils/createActionType";

const MODULE = "alerts";

export const CREATE_ALERT = createActionType(MODULE, "createAlert");
export const DELETE_ALERT = createActionType(MODULE, "deleteAlert");
